import i18n from '@/utils/i18n';
import React from 'react';
import { TextInput, Props as TextInputProps } from './text-input';

export const EmailInput: React.FC<TextInputProps> = ({ value, ...rest }) => {
  return (
    <TextInput
      autoCapitalize="none"
      autoComplete="email"
      autoCorrect={false}
      keyboardType="email-address"
      label={value ? i18n.t('email') : undefined}
      placeholder={i18n.t('email')}
      textContentType="emailAddress"
      value={value}
      {...rest}
    />
  );
};
